import { appConfig } from '@/plugins/micleoConfig'

// eslint-disable-next-line no-undef
export const hcaptcha = appConfig.tokens.HCAPTCHA_SITE_KEY
export default hcaptcha
